import React from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import MsPhdInternational_admissionEle from "./MsPhdInternational_admissionEle";

function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission" />
            <MsPhdInternational_admissionEle />
        </>
    );
}

export default Main;
